import styled from '@emotion/styled';
import { User } from '@kaizenplatform/intelligence-entity';
import {
  Button as _Button,
  ClickAwayListener,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  Paper,
  Popper,
  Typography,
  withStyles,
} from '@material-ui/core';
import { FC, useState, MouseEvent } from 'react';
import theme from '../../../../theme';
import { COLOR_MENU_BACKGROUND, COLOR_MENU_HEADER, COLOR_TEXT_MAIN } from '../../../../theme/colors';
import AvatarWithName from '../../primitive/AvatarWithName';
import CloseIcon from '@material-ui/icons/Close';
import OpenInNew from '@material-ui/icons/OpenInNew';

interface Props {
  user: User | null;
  onClickSignOut: () => void;
  onClickAccountSettings: () => void;
  className?: string;
}

const UserMenu: FC<Props> = ({ user, onClickSignOut, onClickAccountSettings, className }) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const [open, setOpen] = useState<boolean>(false);

  const onClickMenu = (e: MouseEvent<HTMLElement>) => {
    setOpen(true);
    setAnchorEl(e.currentTarget);
  };

  const onRequestClose = () => {
    setOpen(false);
  };

  return (
    <Root className={className}>
      <IconButton size="small" onClick={onClickMenu}>
        <AvatarWithName
          imageUrl={user ? user.profileImageUrl : undefined}
          name={user ? user.name || '' : ''}
          aria-owns={open ? 'menu-appbar' : null}
          aria-haspopup="true"
        />
      </IconButton>

      <Popper open={open} anchorEl={anchorEl} placement="bottom-end" transition disablePortal>
        <ClickAwayListener onClickAway={onRequestClose}>
          <StyledPaper style={{ width: 320, backgroundColor: COLOR_MENU_BACKGROUND }}>
            <List
              style={{
                padding: 0,
              }}
            >
              <ListItem
                style={{
                  height: 48,
                  display: 'flex',
                  justifyContent: 'space-between',
                  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.16)',
                  backgroundColor: COLOR_MENU_HEADER,
                }}
              >
                <Typography
                  variant="body1"
                  style={{
                    position: 'static',
                    fontSize: 16,
                    fontWeight: 800,
                    color: COLOR_TEXT_MAIN,
                  }}
                >
                  アカウントメニュー
                </Typography>
                <IconButton onClick={onRequestClose} style={{ width: 28, height: 28 }}>
                  <CloseIcon style={{ color: COLOR_TEXT_MAIN, width: 24, height: 24 }} />
                </IconButton>
              </ListItem>
              <List
                style={{
                  padding: '16px 0px 24px 0px',
                  maxHeight: 'calc(80vh - 48px)',
                  overflowY: 'auto',
                }}
              >
                <ListItem
                  button
                  onClick={() => {
                    onClickAccountSettings();
                    onRequestClose();
                  }}
                  style={{
                    height: 48,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    flex: 'none',
                    // padding: '16px 16px 16px 32px',
                    margin: '0px 0px',
                  }}
                >
                  <Typography
                    style={{
                      /* Font / 14px / W7 / 100% */
                      fontStyle: 'normal',
                      fontWeight: 800,
                      fontSize: 14,
                      lineHeight: '100%',
                      /* identical to box height, or 14px */

                      /* Color / Black */
                      color: COLOR_TEXT_MAIN,

                      /* Inside Auto Layout */
                      flex: 'none',
                      order: 0,
                      flexGrow: 1,
                    }}
                  >
                    アカウント設定
                  </Typography>
                  <ListItemIcon
                    style={{
                      marginRight: 0,
                      fontSize: '20px',
                      color: COLOR_TEXT_MAIN,
                      justifyContent: 'flex-end',
                    }}
                  >
                    <OpenInNew fontSize="inherit" />
                  </ListItemIcon>
                </ListItem>
                <ListItem
                  button
                  onClick={() => {
                    onClickSignOut();
                    onRequestClose();
                  }}
                  style={{
                    height: 48,
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    flex: 'none',
                    // padding: '16px 16px 16px 32px',
                    margin: '0px 0px',
                  }}
                >
                  <Typography
                    style={{
                      /* Font / 14px / W7 / 100% */
                      fontStyle: 'normal',
                      fontWeight: 800,
                      fontSize: 14,
                      lineHeight: '100%',
                      /* identical to box height, or 14px */

                      /* Color / Black */
                      color: COLOR_TEXT_MAIN,

                      /* Inside Auto Layout */
                      flex: 'none',
                      order: 0,
                      flexGrow: 1,
                    }}
                  >
                    ログアウト
                  </Typography>
                </ListItem>
              </List>
            </List>
          </StyledPaper>
        </ClickAwayListener>
      </Popper>
    </Root>
  );
};

const Root = styled('div')();

const StyledPaper = withStyles({
  rounded: {
    borderRadius: 0,
  },
  elevation1: {
    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.16)',
  },
  [theme.breakpoints.up('sm')]: {},
})(Paper);

export default UserMenu;
